import { ComponentProps, FC } from 'react'
import { IconWrapper } from '../wrapper'

export const IconEmojiPossibleMatch: FC<ComponentProps<typeof IconWrapper>> = (props) => {
  const { size = 20, color = 'currentColor' } = props
  return (
    <IconWrapper {...props} size={size}>
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_15140_44747)">
          <g clip-path="url(#clip1_15140_44747)">
            <path d="M6.66602 12.5H13.3327M7.49935 7.49996H7.50768M12.4993 7.49996H12.5077M18.3327 9.99996C18.3327 14.6023 14.6017 18.3333 9.99935 18.3333C5.39698 18.3333 1.66602 14.6023 1.66602 9.99996C1.66602 5.39759 5.39698 1.66663 9.99935 1.66663C14.6017 1.66663 18.3327 5.39759 18.3327 9.99996Z" stroke={color} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </g>
        </g>
        <defs>
          <clipPath id="clip0_15140_44747">
            <rect width="20" height="20" fill="white"/>
          </clipPath>
          <clipPath id="clip1_15140_44747">
            <rect width="20" height="20" fill="white"/>
          </clipPath>
        </defs>
      </svg>
    </IconWrapper>
  )
}
